import { schema } from 'normalizr';

export const client = new schema.Entity('clients');
export const clientList = [client];



// WEBPACK FOOTER //
// ./src/modules/clients/schema.js